var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "headphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.55 15.4083V12.975C4.55 12.1667 5.18333 11.4417 6.08333 11.4417C6.89167 11.4417 7.61667 12.075 7.61667 12.975V15.3167C7.61667 16.9417 6.26667 18.2917 4.64167 18.2917C3.01667 18.2917 1.66667 16.9333 1.66667 15.3167V10.1833C1.575 5.5 5.275 1.70833 9.95833 1.70833C14.6417 1.70833 18.3333 5.5 18.3333 10.0917V15.225C18.3333 16.85 16.9833 18.2 15.3583 18.2C13.7333 18.2 12.3833 16.85 12.3833 15.225V12.8833C12.3833 12.075 13.0167 11.35 13.9167 11.35C14.725 11.35 15.45 11.9833 15.45 12.8833V15.4083",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0,
    d: "M19.5 0.5V19.5H0.5V0.5H19.5Z",
    stroke: "#9B0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.8fdcda38959468b81726d9cbb0d25c35.svg";
export { ForwardRef as ReactComponent };